// eslint-disable
import { getEnvVariable } from "@/src/helpers/get-env-variable";
import { formatJetHat } from "@emlakjet/commons/helpers/phone-number";

const highlightParagraph = (input, textToHighlight) =>
  input.replace(new RegExp(textToHighlight, "gi"), `<strong><u>$&</u></strong>`);

const phoneMasking = (input, jethat, listingId) => {
  const baseURL = getEnvVariable("EJ_APPS_API_HOSTNAME");
  if (input) {
    const eventMessage = `var eventData = { channel: 'DESKTOP_WEB', reason: 'LISTING_DETAIL', context: 'LISTING', event: 'VIEW_PHONE_LISTING', entityId: ${listingId}};`;
    const xhr = ` var xmlhttp = new XMLHttpRequest();   // new HttpRequest instance 
                    var eventUrl = "${baseURL}/e6t/v1/events";
                    xmlhttp.open("POST", eventUrl);
                    xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                    xmlhttp.send(JSON.stringify(eventData));`;

    // eslint-disable-next-line no-unused-vars
    const showJetHat = `
      function showJethat(node){
        node.innerHTML="<span style='font-size: 16px; font-weight: bold;'>${jethat}</span>";
        ${eventMessage}
        ${xhr}
    }`;
    // eslint-disable-next-line prefer-regex-literals
    const phoneRegexPattern = new RegExp(
      "(((\\+)?[ \\-\\.]*\\d[ \\-\\.]*)?0[ \\-\\.]*((\\(( *))(\\d( *)){3}(\\)( *)))[\\d \\-\\.]*)|(((\\(( *))(\\d( *)){3}(\\)( *)))[\\d \\-\\.]*)|\\+?\\d{12}|\\d{11}",
      "ig"
    );
    let replacedText = input.replace(
      phoneRegexPattern,
      `
        <div style="display: inline-flex; font-size:14px; font-weight: normal;">
          <span style="color:black; font-weight:bold !important;">JetHat</span>
          &nbsp;ile ekstra ücret ödemeden arayın&nbsp;<span onClick="showJethat(this)">
          <span style="color:#52ca46; cursor: pointer; font-weight:bolder">Telefona Bak</span>
        </div>`
    );

    const patterns = [
      { regex: "((\\+[ \\-\\.]*)\\d[\\d \\-\\.]*\\d)", size: 12 }, // + 90 212 344 45 56
      { regex: "((\\d[ \\-\\.]*){2} [\\d \\-\\.]*\\d)", size: 12 }, // 90 212 344 45 56
      { regex: "( (\\d[ \\-\\.]*){2}\\-[\\d \\-\\.]*\\d)", size: 12 }, // work 9-0-2-1-2-3-4-4-5-5-5-6
      { regex: "((\\d\\-){11}\\d)", size: 12 }, // [START OF LINE]9-0-2-1-2-3-4-4-5-5-5-6
      { regex: "((\\d[ \\-\\.]*){2} [\\d \\-\\.]*\\d)", size: 12 }, // 9 0 2 1 2 3 4 4 5 5 5 6
      { regex: "((\\d[ \\-\\.]*)(\\d[ \\-\\.]*){3}(\\d[ \\.]*)*\\d)", size: 11 }, // covers separately 0532 588 01 41 - 0532 257 27 23
      { regex: "(((0\\d{3} \\d{3} \\d{2} \\d{2}) ){3})", size: 33 }, // covers separately 0532 588 01 41 - 0532 257 27 23
      { regex: "((\\d[ \\-\\.]*)(\\d[ \\-\\.]*){3}(\\d[ \\-\\.]*)*\\d)", size: 11 }, // 0 212 344 45 56
      { regex: "((0\\d{3})[ \\-\\.]?(\\d{3})[ \\-\\.]?(\\d{2})[ \\-\\.]?(\\d{2})[ \\-\\.]?(\\d{10}))", size: 21 }, // 0 212 344 45 56
      { regex: "((\\d{3}[ \\-\\.]*)(\\d[ \\-\\.]*)*\\d)", size: 10 }, // 212 344 45 56
      { regex: "(((\\d[ \\-]*){3}[ \\-\\.]*)(\\d[ \\-\\.]*)*\\d)", size: 10 }, // 2 1 2 3 4 4 4 5 5 6
      { regex: "(\\d[ \\-\\.]*(\\d[ \\-\\.]*)*\\d)", size: 7 }, // 344 45 65
    ];

    patterns.forEach((pattern) => {
      const compiledRegex = new RegExp(pattern.regex, "ig");
      const matches = replacedText.match(compiledRegex);
      matches &&
        matches.forEach((m) => {
          const cleanedMatch = m.replace(/[^\d]/gi, "");
          if (cleanedMatch.length === pattern.size) {
            replacedText = replacedText.replace(
              m,
              `
                <div style='display: inline-flex; font-size:14px; font-weight: normal;'>
                    <span style='color:black; font-weight:bold !important;'>JetHat</span>
                    &nbsp;ile ekstra ücret ödemeden arayın&nbsp;
                    <span onClick='showJethat(this)'>
                    <span style='color:#52ca46; cursor: pointer; font-weight:bolder'>Telefona Bak</span>
                </div>`
            );
          }
        });
    });
    return `
      <script>
        function showJethat(node){
          node.innerHTML="<span style='font-size: 16px; font-weight: bold;'>${jethat}</span>";
          ${eventMessage};
          ${xhr}
        }
      </script>
      ${replacedText}
    `;
  }
  return input;
};

const formatPhoneView = (listingOwnerPhone) => {
  if (typeof listingOwnerPhone === "number") {
    listingOwnerPhone = listingOwnerPhone.toString();
  }
  if (listingOwnerPhone) {
    if (listingOwnerPhone.length > 11) {
      if (listingOwnerPhone.charAt(0) === "0") {
        listingOwnerPhone = listingOwnerPhone.slice(0, 11);
      } else {
        listingOwnerPhone = listingOwnerPhone.slice(0, 10);
      }
      listingOwnerPhone = formatJetHat(listingOwnerPhone);
      return listingOwnerPhone.replace(/(\d\d\d\d)(\d\d\d)(\d\d\d\d)/, "($1) $2 $3");
    }
    if (listingOwnerPhone.length === 10 || listingOwnerPhone.length === 11) {
      listingOwnerPhone = formatJetHat(listingOwnerPhone);
      return listingOwnerPhone.replace(/(\d\d\d\d)(\d\d\d)(\d\d\d\d)/, "($1) $2 $3");
    }
    if (listingOwnerPhone.length === 7) {
      listingOwnerPhone = formatJetHat(listingOwnerPhone);
      return listingOwnerPhone.replace(/(\d\d\d)(\d\d\d\d)/, "$1 $2");
    }
  }
  return formatJetHat(listingOwnerPhone);
};

export { highlightParagraph, phoneMasking, formatPhoneView };
